import React from 'react';
import { useSidebar } from '../context/SidebarContext';
import { useBreadcrumb } from '../context/BreadcrumbContext';

const Reports = () => {
  const { setActivePage } = useSidebar();
  const { setPath } = useBreadcrumb();

  React.useEffect(() => {
    setActivePage('report');
    setPath([{ title: 'Dashboard', path: '/' }, { title: 'Report & Analytics', path: '' }]);
  }, [setActivePage, setPath]);

  return <h1>Report & Analytics</h1>;
};

export default Reports;
